module.exports = __webpack_public_path__ + "img/horizontal_7_7_5010.464321d4.png";